import React, {FC} from 'react';

import classNames from 'classnames';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {PriceBlock} from 'mobile/components/cartCheckoutProductItem/components/priceBlock/priceBlock';

import s from '../baseProductItems.scss';

export type PropsType = {
    item: QuoteItemV2;
    removeComponent?: React.ReactNode;
    children?: React.ReactNode;
};

/**
 * Base Accessory product Item
 */
export const BaseAccessoryProductItem: FC<PropsType> = ({children, item, removeComponent}) => {
    return (
        <div className={s.topBar}>
            <div className={s.topBarContent}>
                <div className={s.imageBlock}>
                    <CloudinaryImage
                        alt={item.name}
                        className={classNames(s.image, s.accessoryImage)}
                        src={item.product.image}
                        width="100%"
                    />
                </div>
                <div className={s.shortDetails}>
                    <p className={classNames(s.name, s.accessoryName)}>{item.windowName}</p>
                    {item.product.color && (
                        <p className={classNames(s.color, s.accessoryColor)}>
                            {item.product.color}
                        </p>
                    )}
                    <PriceBlock
                        className={s.inAccessory}
                        finalPrice={item.totalFinalPrice}
                        price={item.totalPrice}
                    />
                    {children}
                </div>
            </div>
            {removeComponent}
        </div>
    );
};
